module.exports = __webpack_public_path__ + "static/media/menu_localizacao.37655905.png";